import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslocoDirective } from '@jsverse/transloco';
import { ChatlioService } from '../../services/support-chat/chatlio.service';

@Component({
  selector: 'app-support-chat-launcher',
  imports: [FaIconComponent, TranslocoDirective],
  templateUrl: './support-chat-launcher.component.html',
  styleUrl: './support-chat-launcher.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportChatLauncherComponent {
  readonly chatlio = inject(ChatlioService);

  openChat(): void {
    this.chatlio.openChat();
  }
}
